(function ($) {

	function open_pickup_widget() {
		// Open widget
		Packeta.Widget.pick(
			zasilkovna_widget_params.zasilkovna_api_key,
			widget_callback,
			{
				"country": zasilkovna_widget_params.country.toLowerCase(),
				"language": zasilkovna_widget_params.language
			}
		)
	}

	// Close
	function close_widget() {
		Packeta.Widget.close();
	}

	function widget_callback(locationData) {

		if (locationData != null && typeof locationData !== "undefined") {
			
			$("input[name='shipping_pickup_point_id']").val(locationData.id);
			$("input[name='shipping_company_name']").val(locationData.place);
			$("input[name='shipping_address_line_1']").val(locationData.street);
			$("input[name='shipping_city']").val(locationData.city);
			$("input[name='shipping_zip']").val(locationData.zip);

			$("input[name=shipping_method_id]").first().trigger("change")
			return true;
		}

		return false;
	}

	$(document).gp_ready(function () {

		$("[data-open-zasilkovna-pickup-point]").off("click").click(function () {

			// Show loading
			$(this).addClass("loading");
			setTimeout(function () {
				$(this).removeClass("loading");
			}, 3000);

			// Open pickup point widget
			open_pickup_widget()
		})
	})


})(jQuery)
